export const breakpoints = {
  xsmall: `400px`,
  small: `550px`,
  medium: `768px`,
  large: `1024px`,
}

